import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { addAnchorTagToUrl, anchorScroll, normalizeHref, validate, mergeStyles, getRelValue, ANCHOR_VIEWER_DATA_HOOK, LINK_VIEWER_DATA_HOOK } from 'wix-rich-content-common';
import pluginLinkSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-link.schema.json';
import { isEqual } from 'lodash';
import { s as styles } from './link-viewer-1109f86f.js';
import { LINK_TYPE } from './types.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class LinkViewer extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleClick", (event) => {
      var _a;
      const { componentData, isInEditor, config, helpers, customAnchorScroll } = this.props;
      const settings = config == null ? void 0 : config[LINK_TYPE];
      if (settings) {
        const { onClick } = settings;
        const { anchor, url } = componentData;
        (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, LINK_TYPE, "Click", componentData);
        onClick == null ? void 0 : onClick(event, (componentData == null ? void 0 : componentData.customData) || this.getHref(url, anchor));
        if (anchor) {
          event.stopPropagation();
          if (!isInEditor) {
            event.preventDefault();
            if (customAnchorScroll) {
              customAnchorScroll(event, anchor);
            } else {
              const anchorString = `viewer-${anchor}`;
              const element = document.getElementById(anchorString);
              addAnchorTagToUrl(anchorString);
              anchorScroll(element);
            }
          }
        }
      }
    });
    __publicField(this, "getHref", (url, anchor) => url ? normalizeHref(url) : `#viewer-${anchor}`);
    validate(props.componentData, pluginLinkSchema);
    const theme = this.props.theme;
    this.styles = mergeStyles({ styles, theme });
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginLinkSchema);
    }
  }
  render() {
    const { componentData, anchorTarget, children, isInEditor } = this.props;
    const { url, anchor, target = anchorTarget, rel } = componentData;
    const anchorProps = {
      href: this.getHref(url, anchor),
      target: anchor ? "_self" : target,
      rel: getRelValue(rel),
      className: classNames(this.styles.link, {
        [this.styles.linkInEditor]: isInEditor,
        [this.styles.linkInViewer]: !isInEditor
      }),
      onClick: this.handleClick
    };
    const dataHook = anchor ? ANCHOR_VIEWER_DATA_HOOK : LINK_VIEWER_DATA_HOOK;
    return /* @__PURE__ */ React.createElement("a", __spreadValues({ "data-hook": dataHook }, anchorProps), children);
  }
}
__publicField(LinkViewer, "propTypes", {
  componentData: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  customAnchorScroll: PropTypes.func,
  settings: PropTypes.object,
  isInEditor: PropTypes.bool,
  config: PropTypes.object,
  helpers: PropTypes.object
});

export { LinkViewer as default };
//# sourceMappingURL=LinkViewer.js.map
